/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ShrubExchange, ShrubExchangeInterface } from "../ShrubExchange";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    name: "Cancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "optionAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "baseAssetAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quoteAssetAmount",
        type: "uint256",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Exercised",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.SmallOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.Signature",
        name: "sig",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "orderId",
        type: "bytes32",
      },
    ],
    name: "OrderAnnounce",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.SmallOrder",
        name: "sellOrder",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.SmallOrder",
        name: "buyOrder",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "buyOrderId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "sellOrderId",
        type: "bytes32",
      },
    ],
    name: "OrderMatched",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "COMMON_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ORDER_TYPEHASH",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature",
        name: "sig",
        type: "tuple",
      },
    ],
    name: "announce",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder[]",
        name: "orders",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon[]",
        name: "commons",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature[]",
        name: "sigs",
        type: "tuple[]",
      },
    ],
    name: "announceMany",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.Order",
        name: "order",
        type: "tuple",
      },
    ],
    name: "cancel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder",
        name: "order",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature",
        name: "sig",
        type: "tuple",
      },
    ],
    name: "depositAndAnnounce",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder[]",
        name: "sellOrders",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder[]",
        name: "buyOrders",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon[]",
        name: "commons",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature[]",
        name: "sellSigs",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature[]",
        name: "buySigs",
        type: "tuple[]",
      },
    ],
    name: "depositAndMatchMany",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "buyOrderSize",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
    ],
    name: "exercise",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
    ],
    name: "getAvailableBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
    ],
    name: "getCurrentNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "commonHash",
        type: "bytes32",
      },
    ],
    name: "getCurrentNonceFromHash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder[]",
        name: "sellOrders",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "size",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isBuy",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerExpire",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
        ],
        internalType: "struct OrderLib.SmallOrder[]",
        name: "buyOrders",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon[]",
        name: "commons",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature[]",
        name: "sellSigs",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct OrderLib.Signature[]",
        name: "buySigs",
        type: "tuple[]",
      },
    ],
    name: "matchOrders",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "positionPoolTokenBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "exposureType",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
    ],
    name: "positionTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "info",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "positionTokenInfo",
    outputs: [
      {
        components: [
          {
            internalType: "enum AppStateLib.ExposureType",
            name: "exposureType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            components: [
              {
                internalType: "address",
                name: "baseAsset",
                type: "address",
              },
              {
                internalType: "address",
                name: "quoteAsset",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "strike",
                type: "uint256",
              },
              {
                internalType: "uint8",
                name: "optionType",
                type: "uint8",
              },
            ],
            internalType: "struct OrderLib.OrderCommon",
            name: "common",
            type: "tuple",
          },
        ],
        internalType: "struct AppStateLib.PositionToken",
        name: "token",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "baseAsset",
            type: "address",
          },
          {
            internalType: "address",
            name: "quoteAsset",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "expiry",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "strike",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "optionType",
            type: "uint8",
          },
        ],
        internalType: "struct OrderLib.OrderCommon",
        name: "common",
        type: "tuple",
      },
    ],
    name: "tokenizePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
    ],
    name: "unwrapPositionToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "positionHash",
        type: "bytes32",
      },
    ],
    name: "userOptionPosition",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "userTokenBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "userTokenLockedBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type ShrubExchangeConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ShrubExchangeConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ShrubExchange__factory extends ContractFactory {
  constructor(...args: ShrubExchangeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ShrubExchange> {
    return super.deploy(overrides || {}) as Promise<ShrubExchange>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ShrubExchange {
    return super.attach(address) as ShrubExchange;
  }
  connect(signer: Signer): ShrubExchange__factory {
    return super.connect(signer) as ShrubExchange__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ShrubExchangeInterface {
    return new utils.Interface(_abi) as ShrubExchangeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ShrubExchange {
    return new Contract(address, _abi, signerOrProvider) as ShrubExchange;
  }
}
